import { render, staticRenderFns } from "./permissions-list.vue?vue&type=template&id=441a22b9&scoped=true"
import script from "./permissions-list.vue?vue&type=script&lang=js"
export * from "./permissions-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441a22b9",
  null
  
)

export default component.exports